import { TNFooterLinks } from 'libs/component-library/src/navigation/TNFooter/components'

const UTMTag = `?utm_source=TheNightly&utm_medium=Referral&utm_campaign=footer&utm_content=footerlink`

export const footerLinks: TNFooterLinks = {
    linkGroups: [
        // Only 1 link group in MVP
        [
            {
                name: 'HOME',
                link: `/`,
            },
            {
                name: 'THE EDITION',
                link: `/editions`,
                forceInternalSSR: true,
            },
            {
                name: 'ABOUT',
                link: `/about`,
            },
            {
                name: 'CONTACT',
                link: `/contact`,
            },
            {
                name: 'EDITORIAL POLICY',
                link: `/editorial-policy${UTMTag}`,
            },
            {
                name: 'EDITORIAL COMPLAINTS',
                link: `/editorial-complaints`,
            },
        ],
    ],
    legalLinks: [
        {
            name: 'Privacy Policy',
            link: `https://sevenwestmedia.com.au/privacy-policies${UTMTag}`,
        },
        {
            name: 'Terms of Use',
            link: `/terms-of-use`,
        },
        { name: 'Site Map', link: `/sitemap` },
    ],
    socialLinks: {
        facebook: {
            name: 'Facebook',
            link: 'https://facebook.com/thenightlyau',
        },
        x: {
            name: 'X',
            link: 'https://x.com/thenightlyau',
        },
        linkedin: {
            name: 'LinkedIn',
            link: 'https://www.linkedin.com/company/the-nightly/',
        },
        instagram: {
            name: 'Instagram',
            link: 'https://www.instagram.com/thenightlyau/',
        },
        youtube: {
            name: 'YouTube',
            link: 'https://youtube.com/@thenightlyau',
        },
        emailPreference: {
            name: 'Manage email preferences',
            link: '/manage-email-preferences',
        },
    },
}
